import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import store from './store'
import { AuthGate } from './scenes'

export default () => (
  <div>
    <Provider store={store}>
      <Router>
        <AuthGate />
      </Router>
    </Provider>
  </div>
)



// WEBPACK FOOTER //
// ./src/App.js